import React from 'react';
import { cn } from '../../utils/cn';

const TextArea = React.forwardRef(({
  className,
  label,
  description,
  error,
  required = false,
  id,
  rows = 4,
  ...props
}, ref) => {
  // Generate unique ID if not provided
  const textareaId = id || `textarea-${Math.random()?.toString(36)?.substr(2, 9)}`;

  return (
    <div className="space-y-2">
      {label && (
        <label
          htmlFor={textareaId}
          className={cn(
            "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
            error ? "text-destructive" : "text-foreground"
          )}
        >
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </label>
      )}

      <textarea
        className={cn(
          "flex min-h-[100px] w-full rounded-md border-2 border-gray-300 bg-background px-3 py-2 text-base md:text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-purple-600 focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors touch-manipulation",
          error && "border-destructive focus-visible:ring-destructive focus-visible:border-destructive",
          className
        )}
        ref={ref}
        id={textareaId}
        rows={rows}
        {...props}
      />

      {description && !error && (
        <p className="text-sm text-muted-foreground">
          {description}
        </p>
      )}

      {error && (
        <p className="text-sm text-destructive">
          {error}
        </p>
      )}
    </div>
  );
});

TextArea.displayName = 'TextArea';

export default TextArea;